import { render, staticRenderFns } from "./FixedAssetShow.vue?vue&type=template&id=003c8ba8&scoped=true"
import script from "./FixedAssetShow.vue?vue&type=script&lang=js"
export * from "./FixedAssetShow.vue?vue&type=script&lang=js"
import style0 from "./FixedAssetShow.vue?vue&type=style&index=0&id=003c8ba8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003c8ba8",
  null
  
)

export default component.exports